import { Component } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { faMagnifyingGlass, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import {ContentService} from "../../../data-access/content.service";

export interface Subject {
  name: string,
  subject_id: number
}
interface OnInit {
  ngOnInit(): void
}

@Component({
    selector: 'subjectList',
    templateUrl: './subjectList.html',
    styleUrls: ['../../userManagement/userRoleAddEdit/userRoleAddEdit.css'],
    standalone: false
})
export class SubjectListComponent implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute, private contentService: ContentService) {
  }
  isOpened = true;
  faMagnifyingGlass = faMagnifyingGlass
  faChevronRight = faChevronRight
  subjects: Subject[] = []
  searchText = ""
  errorDialog = false
  errorText = ""
  isLoading = false
  primaryColor = `color: ${localStorage.getItem('primaryColor')}; margin-right: 0.5rem; flex-shrink: 1;`
  ngOnInit() {
    this.isLoading = true
    this.contentService.getAllSubjects().subscribe((response) => {
      if(response.success) {
        this.subjects = response.result
      } else {
        this.errorDialog = true
        this.errorText = response.msg
      }
      this.isLoading = false
    })
  }

  subjectClick(id: number) {
    this.router.navigate(['dashboard/ContentViewer/SubjectList/CCLTree'], {queryParams: {subject_id: id}})
  }
}
